import {AllCompanyType} from '../../../../service/company/company-type';

import {EditCompanyTransferType} from './company-group-form-type';

export function companyToEditCompany(company: AllCompanyType): EditCompanyTransferType {
    return {
        address: company.address.formattedFull || company.address.formattedShort,
        companyId: String(company.id),
        name: company.name,
        brandId: String(company.brand.id),
        key: String(company.id),
        code: String(company.code),
    };
}

// Columns of the edit-form companies table that support client-side sorting.
export type EditCompanySortFieldType = 'name' | 'code' | 'address';

type EditCompanySortOrderType = 'ascend' | 'descend';

export type EditCompanySortStateType = {field: EditCompanySortFieldType; order: EditCompanySortOrderType} | null;

// Cycles a column through ascending -> descending -> unsorted on repeated header clicks.
export function getNextEditCompanySort(
    current: EditCompanySortStateType,
    field: EditCompanySortFieldType
): EditCompanySortStateType {
    if (!current || current.field !== field) {
        return {field, order: 'ascend'};
    }

    if (current.order === 'ascend') {
        return {field, order: 'descend'};
    }

    return null;
}

// Arrow appended to a sortable column header: ' ↑' ascending, ' ↓' descending, empty when not the active column.
export function getEditCompanySortIndicator(sort: EditCompanySortStateType, field: EditCompanySortFieldType): string {
    if (sort?.field !== field) {
        return '';
    }

    return sort.order === 'ascend' ? ' ↑' : ' ↓';
}

export function sortEditCompanies(
    companies: Array<EditCompanyTransferType>,
    sort: EditCompanySortStateType
): Array<EditCompanyTransferType> {
    if (!sort) {
        return companies;
    }

    const direction = sort.order === 'descend' ? -1 : 1;

    // `numeric` keeps store codes like "2" / "10" in natural order; the list is already fully loaded.
    return [...companies].sort(
        (first, second) => direction * first[sort.field].localeCompare(second[sort.field], [], {numeric: true})
    );
}
